import { render, staticRenderFns } from "./CommunityCalendarEvent.vue?vue&type=template&id=745ffc71&scoped=true&"
import script from "./CommunityCalendarEvent.vue?vue&type=script&lang=ts&"
export * from "./CommunityCalendarEvent.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityCalendarEvent.vue?vue&type=style&index=0&id=745ffc71&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745ffc71",
  null
  
)

export default component.exports